<template>
  <DefaultLayout>
    <div class="row text-center pt-5">
      <div class="col-md-4 offset-4 pt-5">
        <a href="#" class="btn btn-primary btn-md" @click="contactNow">{{ $t('Contact.click-here-to-contact-us') }}</a>
      </div>
    </div>
  </DefaultLayout>
</template>
<script>
import DefaultLayout from './layouts/default/';

export default {
  components: {
    DefaultLayout,
  },
  methods: {
    contactNow() {
      if (window.umami && typeof window.umami.track === 'function') {
        window.umami.track('open-support-modal');
      }
      this.$bus.emit('show-support-form');
    },
  },
};
</script>
